import React, { useContext, useEffect } from "react";
import { Layout } from "../../nq-component";
import { useNavigate } from "react-router-dom";

function NavBar() {
  const { collapsed, setCollapse } = useContext(Layout.Context);
  const location = useNavigate();

  function toggleCollapse() {
    setCollapse(!collapsed);
  }

  useEffect(() => {
    setCollapse(false);
  }, [setCollapse]);

  const backHome = () => {
    location("/");
  };

  return (
    <nav className="navbar navbar-expand-lg bg-primary">
      <div className="container-fluid pt-1 pb-1">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ width: "2.5rem" }}
        >
          <button
            onClick={toggleCollapse}
            type="button"
            className="btn btn-sm btn-link fs-4 ps-0 text-dark"
          >
            <i className="bi bi-justify-left text-white"></i>
          </button>
        </div>

        <div
          onClick={backHome}
          className="d-flex flex-column justify-content-center align-items-center"
        >
          <p className="p-0 m-0 text-white fw-bold fs-5">Forbes</p>
          <p className="p-0 m-0 text-white" style={{ fontSize: ".75rem" }}>
            Financial Consultancy Corporation
          </p>
        </div>
        <div style={{ width: "2.5rem", background: "red" }}></div>
      </div>
    </nav>
  );
}

export default NavBar;
